import { useEffect } from 'react';

/**
 * useDocumentMeta — set the browser title and the <meta name="description">
 * tag on mount. Keeps CSR SEO usable until we migrate to SSR.
 *
 * @param {string} title  — full title, e.g. "Work · BrightLabs"
 * @param {string} desc   — meta description (max ~155 chars)
 * @param {string} [path] — canonical path from the site root (e.g. "/work"),
 *                          drives the canonical URL rewrite.
 */
export function useDocumentMeta(title, desc, path) {
  useEffect(() => {
    if (title) document.title = title;

    if (desc) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
      }
      el.setAttribute('content', desc);

      let og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute('content', desc);

      let tw = document.querySelector('meta[name="twitter:description"]');
      if (tw) tw.setAttribute('content', desc);
    }

    if (title) {
      let ogt = document.querySelector('meta[property="og:title"]');
      if (ogt) ogt.setAttribute('content', title);
      let twt = document.querySelector('meta[name="twitter:title"]');
      if (twt) twt.setAttribute('content', title);
    }

    if (path) {
      const canonicalHref = `https://brightlabs.live${path}`;
      let canon = document.querySelector('link[rel="canonical"]');
      if (!canon) {
        canon = document.createElement('link');
        canon.setAttribute('rel', 'canonical');
        document.head.appendChild(canon);
      }
      canon.setAttribute('href', canonicalHref);

      let ogu = document.querySelector('meta[property="og:url"]');
      if (ogu) ogu.setAttribute('content', canonicalHref);
    }
  }, [title, desc, path]);
}
